customElements.get("product-swatches") || customElements.define("product-swatches", class extends HTMLElement {
  constructor() {
    super(), this.swatchElements = this.querySelectorAll(".metacolour-swatch__parent"), 
    this.activeTitleEL = this.querySelector("[data-active-title]"), this.handleME = this.handleME.bind(this), 
    this.handleML = this.handleML.bind(this);
  }
  handleME(t) {
    const e = t.currentTarget.getAttribute("data-swatch-name");
    e && (this.activeTitleEL.setAttribute("data-original-text", this.activeTitleEL.textContent), 
    this.activeTitleEL.textContent = e);
  }
  handleML(t) {
    this.activeTitleEL.textContent = this.activeTitleEL.getAttribute("data-original-text");
  }
  connectedCallback() {
    this.swatchElements.length && this.swatchElements.forEach(t => {
      t.addEventListener("mouseenter", this.handleME), t.addEventListener("mouseleave", this.handleML);
    });
  }
  disconnectedCallback() {
    this.swatchElements.length && this.swatchElements.forEach(t => {
      t.removeEventListener("mouseenter", this.handleME), t.removeEventListener("mouseleave", this.handleML);
    });
  }
});